import axios from '@/api/axiosInstance';

export default async function getGamificationProgress() {
  const response = await axios.get(
    `${process.env.NEXT_PUBLIC_API_V2}/gamificationProgress`
  );
  return response.data;
}
